import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import PubSub from 'services/PubSub/';
import ImageLoad from 'components/ImageLoad';
import notImage from 'images/foto_en_preparacion.png';
import TagManagerService from 'services/TagManager';
import { translateFlag } from 'config/constants';
import StorageService from 'services/StorageService';
import { getImageV2 } from 'utils';
import style from './style.scss';//NOSONAR

const ShelfSameProduct = (props) => {
    let controlsConfig = null;
    const product = props.product;
    const item = product.items ? product.items[0] : false;
    const notPDP = props.notPDP;
    const mobileVersion = props.mobileVersion;

    const [load] = useState(null);

    if (item) {
        controlsConfig = {
            unitSale: (product['Pesable x Unidad'] && product['Pesable x Unidad'][0]) ? translateFlag[product['Pesable x Unidad'][0]] : false,
            unitMultiplier: item.unitMultiplier,
            measurementUnit: item.measurementUnit,
            maxItems: item.maxItems - (item.inCart ? item.inCart : 0),
            customClass: props.small ? props.small : false,
            tagManagerData: { product: product, listTitle: props.listTitle, position: props.position }
        };
    }

    const openPreView = (prod) => {
        PubSub.dispatch('open_product_preview', { product: prod, title: props.listTitle, position: props.position });
    }

    const openModalAddToList = (itemID) => {
        PubSub.dispatch('add_to_list_open', { skuId: itemID, config: controlsConfig });
    }

    const producRedirect = () => {
        PubSub.dispatch('product_redirect');
    }

    const productClick = () => {
        TagManagerService.productClick(props.product, props.listTitle, props.position);

        StorageService.setItem('list_pdp', props.listTitle);
    }

    const productImage = item ? getImageV2(item, 360) : product.ImageUrl;
    const link = notPDP ? '#' : (product.linkText ? `/${product.linkText}/p` : '');
   
    const productName = product.productName || product.ProductName;
    if (item) {
        item.skuData = item.skuData || {};
    }

    const extraActions = (
        <div className="shelf-product-extra-actions">
            {item && <button className="font-icn view-more tooltip-container mobile-click" onClick={() => openPreView(product)}>
                <span className="tooltip">Vista Rápida</span>
            </button>}
            <button className="tooltip-container mobile-click" onClick={() => openModalAddToList(item.itemId || product.Id)}>
                <i className="add-list-icon jumbo-icon-new-list"></i>
                <span className="tooltip">Agregar a una lista</span>
            </button>
        </div>
    );

    return (
        <div className={"shelf-same-product"+ (mobileVersion ? ' mobile-version ' : '')}>
            <span className="title-same-product">Estás viendo</span>
            <div className={"shelf-same-product-top"} onClick={() => producRedirect()}>
                <div className="shelf-same-product-image">
                    {!load && extraActions}
                    <Link to={link} onClick={productClick} className="shelf-wrap-image-same-product" aria-label={productName}>
                        {productImage && <ImageLoad src={productImage} errorImage={notImage} alt={productName} gtmData={props.gtmData} />}
                        {!productImage && <ImageLoad src={notImage} errorImage={notImage} alt={productName} gtmData={props.gtmData} />}
                    </Link>
                </div>
            </div>
        </div>
    )
}

ShelfSameProduct.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool,
    gtmData: PropTypes.object,
    variant: PropTypes.string
};

export default ShelfSameProduct